import { NavLink } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faPenToSquare, faTrash, faEye } from '@fortawesome/free-solid-svg-icons';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField, FormControlLabel, Checkbox, DialogContentText, Stack, Alert, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import React from "react";
import { useTablePDFDownload } from "../utils/GenratePdfA4Table";

export default function VehicleProperty() {
    const [searchTerm, setSearchTerm] = useState('');
    const [listingData, setListingData] = useState([]);   
    const [isAddOpen, setIsAddOpen] = useState(false);  
    const [listingDataLoading, setListingDataLoading] = useState(false);  
    const [page, setPage] = useState(1);
    const [vehicleType, setVehicleType] = useState('');
    // Alert message
    const [alertVisible, setAlertVisible] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertSeverity, setAlertSeverity] = useState('success');

    const [dialogData, setDialogData] = useState({ title: "", action: "", id: null });
    const [showDialog, setShowDialog] = useState(false);  
    const [showErrorDialog, setShowErrorDialog] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [viewDialog, setViewDialog] = useState(false);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [idToDelete, setIdToDelete] = useState(null);
    const [viewIdCardPath, setViewIdCardPath] = useState({tenant_national_id_card: ""});
    const [uploadedFileName, setUploadedFileName] = useState("");
    const [formData, setFormData] = useState({
        id: "",
        room_number: "",
        license_plate: "",
        type: "",
        price: "",
    });
    const [buildingNameExtract, setBuildingNameExtract] = useState('');

    // =================>> Print room button on click
    const togglePrint = () => {
        window.print();
    };

    // =================>> Print
    const tableRef = useRef(null);
    const downloadTable = useTablePDFDownload(tableRef);
    
    // =================>> Add room button on click
    const toggleAdd = () => {
        setDialogData({ title: "បង្កើតអ្នកជួលចំណតថ្មី", action: "add" });
        setFormData({
            id: "",
            room_number: "",
            license_plate: "",
            type: "",
            price: ""
        });
        setShowDialog(true);
    };

    // ========================>> Action buttons

    const renderActionButton = (id) => {
        return (
            <div className="render-action-buttons flex">
                <button onClick={() => {handleEditListing(id)}} className="flex bg-blue-700 rounded-xl py-1 pl-2 pr-1 lg:px-3 text-white text-sm justify-center items-center mr-3">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-4 mr-1">
                        <path strokeLinecap="round" strokeLinejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125" />
                    </svg>
                    <span className="hidden lg:flex">Edit</span>
                </button>
                <button onClick={() => {handleDeleteListing(id)}} className="flex bg-red-700 rounded-xl py-1 pl-2 pr-1 lg:px-3 text-white text-sm justify-center items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-4 mr-1">
                        <path strokeLinecap="round" strokeLinejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
                    </svg>
                    <span className="hidden lg:flex">Delete</span>
                </button>
            </div>
        )
    }

    const handleEditListing = (data) => {
        setFormData({
            id: data.id,
            room_number: data.room.room_number,
            license_plate: data.license_plate,
            type: data.type.name,
            price: Number(data.price)
        });
        setDialogData({ title: "កែប្រែអ្នកជួលចំណត", action: "edit", data });
        setShowDialog(true);
    }

    // ================>>   Fetch data for displaying in the table

    useEffect(() => {
        fetchView();
    }, []);

    const fetchView = async (page1 = 1, type, limit = 10) => {
        setListingDataLoading(true);

        try {
            const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/vehicle?type=${type}&page=${page1}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Failed to fetch data.');
            }

            const dataExpense = await response.json();
            setListingData(dataExpense);
        } catch (err) {
            console.error(err.message);
        } finally {
            setListingDataLoading(false);
        }
    };

    useEffect(() => {
    }, [listingData]); 

    useEffect(() => {
        fetchView(page, vehicleType);  
    }, [page, vehicleType]);

    // Fetch data for searching
    const handleSearchSubmit = async (event) => {
        event.preventDefault(); 
        fetchSearch(searchTerm); 
    };  

    // ============>> View id card 
    const handleViewIdCard = (tenant_national_id_card) => {
        setViewDialog(true);
        setViewIdCardPath({tenant_national_id_card: tenant_national_id_card});
    }

    // ======================>>   Handle form submission for Add/Edit
    const handleSubmit = (event) => {
        event.preventDefault();
        console.log(formData)
    
        const method = dialogData.action === "add" ? "POST" : "PUT";
        const url = dialogData.action === "add"
            ? `${process.env.REACT_APP_API_ENDPOINT}/vehicle`
            : `${process.env.REACT_APP_API_ENDPOINT}/vehicle/${formData.id}`;
    
        // // Use FormData for file upload
        // const dataToSubmit = new FormData();
    
        // // Add all fields to FormData
        // Object.keys(formData).forEach((key) => {
        //     if (formData[key] !== null && formData[key] !== undefined) {
        //         if (key === "tenant_national_id_card" && formData[key] instanceof File) {
        //             // Append the file for the `tenant_national_id_card` field
        //             dataToSubmit.append(key, formData[key]);
        //         } else {
        //             // Append other fields as text
        //             dataToSubmit.append(key, formData[key]);
        //         }
        //     }
        // });
    
        if (!formData.room_number) {
            setErrorMessage("សូមបញ្ចូលលេខបន្ទប់");
            setShowErrorDialog(true);
            return;
        }
    
        if (!formData.price) {
            setErrorMessage("សូមបញ្ចូលឈ្នួលប្រចាំខែ");
            setShowErrorDialog(true);
            return;
        }

        if (!formData.type) {
            setErrorMessage("សូមបញ្ចូលប្រភេទយានយន្ត");
            setShowErrorDialog(true);
            return;
        }
    
        if (!formData.license_plate) {
            setErrorMessage("សូមបញ្ចូលស្លាកលេខ");
            setShowErrorDialog(true);
            return;
        }
    
        fetch(url, {
            method,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                'Content-Type': 'application/json', 
            },
            body: JSON.stringify(formData), 
        })
        .then((response) => {
            if (!response.ok) {
                return response.json().then((data) => {
                    throw data;
                });
            }
            return response.json();
        })
        .then(() => {
            setShowDialog(false);
            setAlertMessage("យានជំនិះត្រូវបានធ្វើបច្ចុប្បន្នភាពដោយជោគជ័យ");
            setAlertSeverity("success");
            setAlertVisible(true);
            setTimeout(() => {
                setAlertVisible(false);
            }, 2000);
            fetchView(); // Refresh listings after add/edit
        })
        .catch((error) => {
            console.error('Error saving listing:', error);

            const customMessages = {
                room_number: 'សូមបញ្ចូលលេខបន្ទប់',
                price: 'សូមបញ្ចូលឈ្នូលប្រចាំខែ',
            };

            if (Array.isArray(error.message)) {
                const formattedErrors = error.message.map(err => {
                    const customMessage = customMessages[err.property] || `Error with ${err.property}`;
                    return customMessage;
                }).join('\n');

                setErrorMessage(formattedErrors);
            } else {
                setErrorMessage(error.message || 'An unknown error occurred');
            }
            setShowErrorDialog(true);
        });
        setUploadedFileName('');
    };

    // Handle form input changes
    const handleInputChange = (e) => {
        const { name, value, files } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: files ? files[0] : value, // Use `files[0]` for file input
        }));
    };
    
    const fetchSearch = async (searchTerm) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/vehicle/search?search=${searchTerm}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'Content-Type': 'application/json'
                }
            });
    
            if (!response.ok) {
                throw new Error('Failed to fetch search');
            }
    
            const data = await response.json(); 
            setListingData(data); 
        } catch (error) {
            console.error('Error fetching search:', error);
        }
    };

    // =======================>> Delete

    const handleDeleteListing = (idToDelete) => {
        setIdToDelete(idToDelete.id);
        setDeleteDialogOpen(true); // Open the confirmation dialog
    };

    const confirmDelete = async () => {
        setDeleteDialogOpen(false); // Close the dialog
        if (!idToDelete) return;

        try {
            const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/vehicle/${idToDelete}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                throw new Error("Failed to delete payment"); // Handle non-2xx responses
            }

            // Show success alert
            setAlertMessage("យានជំនិះត្រូវបានលុបដោយជោគជ័យ");
            setAlertSeverity("success");
            setAlertVisible(true);

            setTimeout(() => {
                setAlertVisible(false);
            }, 1000);
            fetchView();
        } catch (error) {
            console.error(error.message);
            setAlertMessage(error.message);
            setAlertSeverity("error");
            setAlertVisible(true);
        }
    };

    return (
        <div className="w-full h-[100dvh] bg-white">
            {/* Header */}
            <div className="w-full h-[8dvh] bg-primary2 flex  items-center">
                <div className="md:w-[8%] pl-3 md:pl-10 items-center flex text-customWhite">
                    <NavLink to='/'>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-12">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 15.75 3 12m0 0 3.75-3.75M3 12h18" />
                        </svg>
                    </NavLink>
                </div>
                <div className="w-[84%] flex justify-center">
                    <h2 className="text-2xl font-semibold text-customWhite">ទិន្នន័យអ្នកជួលចំណតយានជំនិះ</h2>
                </div>
            </div>

            <div className="pt-5">
                <div className="mb-7 flex w-full lg:px-10 flex-col items-center md:items-stretch md:flex-row">
                    <form onSubmit={handleSearchSubmit} className="w-[100%] md:w-[35%] flex justify-center md:justify-stretch">
                        <div className="search-box !w-[90%] md:!w-[85%] pt-5">
                            <FontAwesomeIcon icon={faSearch} className="search-icon" />
                            <input
                                type="text"
                                placeholder="Search"
                                className=""
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)} 
                            />
                        </div>
                    </form>
                    <div className="mx-10 border-2 border-gray-300 rounded-full flex">
                        <button className={`rounded-l-full text-black px-10 text-lg hover:bg-gray-200 border-r-2 border-gray-300 ${vehicleType == 'Motorbike' ? 'bg-gray-300' : 'bg-white'}`} onClick={() => setVehicleType('Motorbike')}>ម៉ូតូ {listingData && listingData.vehicleTypeCounts && (<span className="px-2 py-1 text-base bg-gray-200 font-semibold rounded-full">{listingData.vehicleTypeCounts.Motorbike}</span>)}</button>
                        <button className={`text-black px-10 text-lg hover:bg-gray-200 border-r-2 border-gray-300 ${vehicleType == 'PASSAPP' ? 'bg-gray-300' : 'bg-white'}`} onClick={() => setVehicleType('PASSAPP')}>PASSAPP {listingData && listingData.vehicleTypeCounts && (<span className="px-2 py-1 text-base bg-gray-200 font-semibold rounded-full">{listingData.vehicleTypeCounts.PASSAPP}</span>)}</button>
                        <button className={`rounded-r-full text-black px-10 text-lg hover:bg-gray-200 ${vehicleType == 'Tuktuk' ? 'bg-gray-300' : 'bg-white'}`} onClick={() => setVehicleType('Tuktuk')}>កង់បី {listingData && listingData.vehicleTypeCounts && (<span className="px-2 py-1 text-base bg-gray-200 font-semibold rounded-full">{listingData.vehicleTypeCounts.Tuktuk}</span>)}</button>
                    </div>
                    <div className="md:ml-auto flex mt-5 md:mt-0">
                        <button onClick={downloadTable} className="h-14 bg-white hover:bg-gray-200 font-medium text-black px-10 ml-5 rounded-lg duration-200 mr-5">↓ ទាញយក</button>
                        <button className="bg-secondary1 hover:shadow-md px-10 py-1 sm:py-2 items-center lg:py-2 rounded-3xl text-white flex text-xl sm:text-base lg:text-lg" onClick={toggleAdd}><span className="text-2xl">+</span> <span className="sm:flex sm:ml-1">បន្ថែម</span><span className="hidden md:!flex lg:ml-0">ថ្មី</span></button>
                    </div>
                </div>
                
                {listingDataLoading ? (
                <div className="text-center my-10">
                    <p>Loading data...</p>
                </div>
            ) : (
                <div className="overflow-x-auto overflow-y-auto !h-[76vh]">
                    <table className="table-display w-[100%]" ref={tableRef}>
                        <thead className="!bg-secondary3 border-2">
                            <tr>
                                {/* <th className="rounded-tl-lg text-zinc-800  text-xs md:text-sm lg:!text-base">បន្ទប់</th> */}
                                <th className="text-zinc-800  text-xs md:text-sm lg:!text-base !py-4 ml-3">លេខបន្ទប់</th>
                                <th className="text-zinc-800  text-xs md:text-sm lg:!text-base !py-4">យានជំនិះ</th>
                                <th className=" text-zinc-800  text-xs md:text-sm lg:!text-base !py-4">ស្លាកលេខ</th>
                                <th className=" text-zinc-800  text-xs md:text-sm lg:!text-base !py-4">ឈ្មោះម្ចាស់</th>
                                <th className=" text-zinc-800 text-xs md:text-sm  lg:!text-base !py-4">លេខទូរស័ព្ទ</th>
                                <th className=" text-zinc-800 text-xs md:text-sm lg:!text-base !py-4">អត្ត.ប័ណ្ណ</th>
                                <th className=" text-zinc-800 text-xs md:text-sm  lg:!text-base !py-4">ថ្ងៃជួល</th>
                                <th className="text-zinc-800 text-xs md:text-sm lg:!text-base !py-4">កែសម្រួល</th>
                            </tr>
                        </thead>
                        <tbody>
                            {listingData && listingData.data? (
                                
                                listingData.data.map((listing, index) => (
                                    <tr key={index} className="even:bg-gray-100 hover:bg-gray-200">
                                        <td className=" text-xs md:text-sm lg:!text-base !py-4 ml-3">{listing.room.room_number || 'N/A'}</td>
                                        <td className="font-medium text-xs md:text-sm lg:!text-base !py-4">
                                            {listing.type.name === 'Motorbike' ? 'ម៉ូតូ' :
                                            listing.type.name === 'Tuktuk' ? 'កង់បី' :
                                            listing.type.name === 'PASSAPP' ? 'PASS APP' :
                                            listing.type.name === 'Car' ? 'ឡាន' :
                                            '--'}
                                        </td>
                                        <td className="font-medium text-gray-600 text-xs md:text-sm lg:!text-base">
                                            {listing.license_plate}
                                        </td>
                                        <td className="font-medium text-gray-600 text-xs md:text-sm lg:!text-base">
                                            {listing.room.tenant ? listing.room.tenant : '--'}
                                        </td>
                                        <td className="font-medium text-gray-600 text-xs md:text-sm lg:!text-base !py-4">
                                            {listing.room.tenant_phone_number 
                                                ? listing.room.tenant_phone_number.replace(/(\d{3})(\d{3})(\d{3,4})/, '$1 $2 $3') 
                                                : '--'}
                                        </td>
                                        <td className="font-medium text-gray-600 text-xs md:text-sm lg:!text-base !py-4 flex justify-center">
                                            <div className="w-full flex">
                                                <button onClick={() => {handleViewIdCard(listing.tenant_national_id_card)}} className="flex bg-orange-400 rounded-xl py-1 pl-2 pr-1 lg:px-3 text-white text-sm justify-center items-center mr-3">
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-5 flex mr-1 lg:hidden">
                                                        <path strokeLinecap="round" strokeLinejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
                                                        <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                                                    </svg>
                                                    <span className="hidden lg:flex">View</span>
                                                </button>
                                            </div>
                                        </td>
                                        <td className="font-medium text-gray-600 text-xs md:text-sm lg:!text-base !py-4">
                                            {listing.updated_at 
                                                ? new Date(listing.updated_at).toLocaleDateString('en-GB', { 
                                                    day: '2-digit', 
                                                    month: '2-digit', 
                                                    year: 'numeric' 
                                                }).replace(/\//g, '-') 
                                                : '--'}
                                        </td>
                                        <td className="w-[15%]">{renderActionButton(listing)}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="7">No records found for the selected month and year.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                )}
                {alertVisible && (
                    <Stack sx={{ width: '100%', justifyContent: "flex-end",
                        alignItems: "flex-end", }}  mt={-5} spacing={2} borderRadius={2}>
                        <Alert severity={alertSeverity} sx={{fontWeight: 500, fontSize: '16px'}}>
                            {alertMessage}
                        </Alert>
                    </Stack>
                )}
            </div>
            <Dialog open={viewDialog} onClose={() => setViewDialog(false)}>
                {viewIdCardPath.tenant_national_id_card ? (
                <img src={`${process.env.REACT_APP_API_ENDPOINT}${viewIdCardPath.tenant_national_id_card}`} />
                ) : (
                    <p className="font-kantumruy text-xl font-medium px-16 py-8">មិនមានអត្តសញ្ញាណប័ណ្ណរបស់ម្ចាស់បន្ទប់នេះទេ</p>
                )}
            </Dialog>
            {/* Dialog for Add/Edit */}
            <Dialog open={showDialog} onClose={() => setShowDialog(false)} sx={{
                '& .MuiDialogTitle-root, & .MuiDialogContent-root, & .MuiDialogActions-root': {
                    fontFamily: 'Kantumruy Pro, sans-serif'
                }
            }}>
                <DialogTitle>{dialogData.title}</DialogTitle>
                <DialogContent>
                <form onSubmit={handleSubmit}>
                    <div className="flex space-x-4">
                        <TextField
                        margin="dense"
                        label="លេខបន្ទប់ *"
                        name="room_number"
                        value={formData.room_number !== null ? formData.room_number : ''}
                        onChange={handleInputChange}
                        fullWidth
                        InputLabelProps={{
                            style: { fontFamily: 'Kantumruy Pro' },
                        }}
                        InputProps={{
                            style: {
                              borderRadius: "8px",
                              fontFamily: 'Kantumruy Pro',
                            }
                        }}
                        />
                        <FormControl
                        fullWidth
                        margin="dense"
                        sx={{
                            '& .MuiInputLabel-root': {
                            fontFamily: 'Kantumruy Pro',
                            },
                            '& .MuiSelect-select': {
                            borderRadius: "8px",
                            fontFamily: 'Kantumruy Pro',
                            },
                        }}
                        >
                            <InputLabel>ប្រភេទយានយន្ត *</InputLabel>
                            <Select
                                name="type"
                                value={formData.type || ""}
                                onChange={handleInputChange}
                                label="ប្រភេទយានយន្ត *"
                            >
                                <MenuItem value="Motorbike" sx={{fontFamily: 'Kantumruy Pro'}}>ម៉ូតូ</MenuItem>
                                <MenuItem value="Tuktuk" sx={{fontFamily: 'Kantumruy Pro'}}>កង់បី</MenuItem>
                                <MenuItem value="PASSAPP" sx={{fontFamily: 'Kantumruy Pro'}}>PASSAPP</MenuItem>
                                <MenuItem value="Car" sx={{fontFamily: 'Kantumruy Pro'}}>រថយន្ត</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                    <TextField
                        margin="dense"
                        label="ស្លាកលេខ *"
                        name="license_plate"
                        value={formData.license_plate !== null ? formData.license_plate : ''}
                        onChange={handleInputChange}
                        fullWidth
                        InputLabelProps={{
                            style: { fontFamily: 'Kantumruy Pro' },
                        }}
                        InputProps={{
                            style: {
                              borderRadius: "8px",
                              fontFamily: 'Kantumruy Pro',
                            }
                        }}
                    />
                    <TextField
                        margin="dense"
                        label="ឈ្នួលក្នុង១ខែ *"
                        name="price"
                        value={formData.price !== null ? formData.price : ''}
                        onChange={handleInputChange}
                        fullWidth
                        InputLabelProps={{
                            style: { fontFamily: 'Kantumruy Pro' },
                        }}
                        InputProps={{
                            style: {
                            borderRadius: "8px",
                            fontFamily: 'Kantumruy Pro',
                            }
                        }}
                    />
                </form>
                </DialogContent>
                <DialogActions sx={{marginBottom: "16px"}}>
                <Button onClick={() => setShowDialog(false)} color="black"  
                sx={{paddingY: "8px", paddingX: "32px", marginRight: "16px",'&:hover': {
                    backgroundColor: '#f9f9f9',
                }, }}>
                    Cancel
                </Button>
                <Button onClick={handleSubmit} sx={{background: "#00B4D8", color: "white", paddingY: "8px", paddingX: "32px", marginRight: "16px" }}>
                    Save
                </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={showErrorDialog} onClose={() => setShowErrorDialog(false)} sx={{
                '& .MuiDialogTitle-root, & .MuiDialogContent-root, & .MuiDialogActions-root': {
                    fontFamily: 'Kantumruy Pro, sans-serif',
                }
            }}>
                <DialogTitle sx={{color: "red"}}>Error</DialogTitle>
                <DialogContent>
                    <div style={{ whiteSpace: 'pre-line' }}>
                        {errorMessage}
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setShowErrorDialog(false)} color="secondary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
                <DialogTitle sx={{ fontFamily: 'Kantumruy Pro'}}>បញ្ជាក់ការលុបបន្ទប់</DialogTitle>
                <DialogContent>
                    <DialogContentText sx={{ fontFamily: 'Kantumruy Pro'}}>
                        តើអ្នកពិតជាចង់់លុបបន្ទប់នេះមែនទេ?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDeleteDialogOpen(false)} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={confirmDelete} color="primary">
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>

        </div>
    )
}